import React, { useMemo } from "react";
import CustomCard from "../Card";
import { EChartsOption } from "echarts";
import ReactEchart from "../../../../molecules/ReactEchart";

const SubLocation: React.FC = React.memo(() => {
  const options: EChartsOption = useMemo(
    () => ({
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: (params: any) => {
          const { name, value } = params[0];
          return `${name}: ${value}`;
        },
      },
      grid: {
        left: "5%",
        right: "10%",
        bottom: "5%",
        containLabel: true,
      },
      xAxis: {
        type: "value",
        splitLine: { show: false },
      },
      yAxis: {
        type: "category",
        inverse: true,
        data: [
          "Al Muraqqabat",
          "Al Muteena",
          "Al Refaa",
          "Al Barsha First",
          "Al Warqa First",
          "Al Mankhool",
          "Al Hamriya",
          "Al Qusais First",
          "Port Saeed",
          "Naif",
        ],
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          fontSize: 14,
          color: "#1F5782",
        },
      },
      series: [
        {
          type: "bar",
          data: [900, 800, 700, 600, 500, 410, 300, 200, 150, 100],
          barWidth: "50%",
          itemStyle: {
            borderRadius: [5, 5, 5, 5],
            color: "#1F5782",
          },
          label: {
            show: true,
            position: "right",
            fontSize: 14,
            fontWeight: "bold",
            formatter: ({ value }) => `${value}`,
            color: "#1F5782",
          },
        },
      ],
    }),
    []
  );

  return (
    <CustomCard heading="CASE /" subHeading="SUB-LOCATION">
      <ReactEchart
        options={options}
        style={{ height: "445px", width: "100%" }}
      />
    </CustomCard>
  );
});

export default SubLocation;
